import React, { useEffect, useState } from 'react';

import axios from 'axios';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import { useNavigate, useParams } from 'react-router-dom';
import config from '../../config';

import Progressbar from './Progressbar';

const ScheduleInspectionYardPlacement = () => {
  const navigate = useNavigate();

  const { repoId } = useParams();
  const decodedRepoId = repoId ? atob(repoId) : '';

  const userData = useSelector((state) => state.userInfo);

  const API_SERVER = config.API_BASE_URL;

  const [showPopup, setShowPopup] = useState(false);
  const [repoCurrentStep, setRepoCurrentStep] = useState('Pending');

  // --- PRELOADER: tracks POST request in-flight state ---
  const [postLoading, setPostLoading] = useState(false);

  const [yardList, setYardList] = useState([]);

  const [formData, setFormData] = useState({
    inspection_date: '',
    inspection_time: '',

    yard_name: '',
    yard_address: '',

    refurbishment_required: '',
  });

  useEffect(() => {
    const now = new Date();

    const date = now.toISOString().split('T')[0];

    const time = now.toTimeString().slice(0, 5);

    setFormData((prev) => ({
      ...prev,

      inspection_date: date,
      inspection_time: time,
    }));

    getData();
    getAllYards();
    fetchRepoProgress();
  }, []);

  const getData = async () => {
    try {
      const res = await axios.get(`${API_SERVER}getYardPlacement/${decodedRepoId}`);

      if (res.data.status && res.data.data) {
        setFormData(res.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const getAllYards = async () => {
    try {
      const res = await axios.get(`${API_SERVER}getAllYardMaster`);

      if (res.data.status) {
        setYardList(res.data.data || []);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const fetchRepoProgress = async () => {
    try {
      const res = await fetch(`${API_SERVER}get-repo-progress-flow?repo_id=${decodedRepoId}`);

      const result = await res.json();

      if (result.status) {
        setRepoCurrentStep(result.current_step);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === 'yard_name') {
      const selectedYard = yardList.find((item) => item.yard_name === value);

      setFormData({
        ...formData,

        yard_name: value,

        yard_address: selectedYard?.yard_address || '',
      });
    } else {
      setFormData({
        ...formData,

        [name]: value,
      });
    }
  };

  const handleSave = async () => {
    if (!formData.inspection_date || !formData.inspection_time || !formData.yard_name || !formData.yard_address) {
      alert('Please enter mandatory fields');

      return;
    }

    setShowPopup(true);
  };

  const finalSave = async (type) => {
    // --- PRELOADER: show overlay before POST request ---
    setPostLoading(true);

    try {
      const payload = new FormData();

      payload.append('repo_id', decodedRepoId);

      payload.append('inspection_date', formData.inspection_date);

      payload.append('inspection_time', formData.inspection_time);

      payload.append('yard_name', formData.yard_name);

      payload.append('yard_address', formData.yard_address);

      payload.append('refurbishment_required', type);

      payload.append('created_by', userData?.id);

      payload.append('updated_by', userData?.id);

      const res = await axios.post(`${API_SERVER}saveYardPlacement`, payload);

      if (res.data.status) {
        toast.success(res.data.message || 'Data saved successfully');

        setTimeout(() => {
          if (type === 'yes') {
            navigate(`/dashboard/refurbishment-detail/${btoa(decodedRepoId)}`);
          } else {
            navigate(`/dashboard/final-submission/${btoa(decodedRepoId)}`);
          }
        }, 1200);
      }
    } catch (err) {
      console.log(err);

      toast.error(err?.response?.data?.message || 'Something went wrong');
    } finally {
      setPostLoading(false);
    }
  };

  return (
    <div className="container-fluid">
      {postLoading && (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            width: '100%',
            height: '100%',
            background: 'rgba(255,255,255,0.85)',
            zIndex: 9999,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            backdropFilter: 'blur(3px)',
          }}
        >
          <div
            style={{
              width: '56px',
              height: '56px',
              border: '5px solid #e0e0e0',
              borderTop: '5px solid #1976d2',
              borderRadius: '50%',
              animation: 'spin 0.8s linear infinite',
            }}
          />
          <p style={{ marginTop: '18px', fontWeight: 600, color: '#1976d2', fontSize: '15px' }}>
            Saving, please wait...
          </p>
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              style={{
                width: '320px',
                height: '14px',
                borderRadius: '6px',
                marginTop: '10px',
                background: 'linear-gradient(90deg,#e0e0e0 25%,#f5f5f5 50%,#e0e0e0 75%)',
                backgroundSize: '400% 100%',
                animation: 'shimmer 1.4s infinite',
              }}
            />
          ))}
          <style>{`
            @keyframes spin { to { transform: rotate(360deg); } }
            @keyframes shimmer { 0%{background-position:100% 0} 100%{background-position:-100% 0} }
          `}</style>
        </div>
      )}
      {/* --- END PRELOADER OVERLAY --- */}

      <div className="card shadow-sm">
        <div className="card-body">
          <h4 className="mb-4">Schedule Inspection / Yard Placement</h4>

          <div className="mb-4">
            {/* <Progressbar currentStep={repoCurrentStep} /> */}
          </div>

          <div className="row">
            <div className="col-md-6 mb-3">
              <label>Inspection Date *</label>

              <input
                type="date"
                name="inspection_date"
                className="form-control"
                value={formData.inspection_date}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Inspection Time *</label>

              <input
                type="time"
                name="inspection_time"
                className="form-control"
                value={formData.inspection_time}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-6 mb-3">
              <label>Yard Name *</label>

              <select name="yard_name" className="form-control" value={formData.yard_name} onChange={handleChange}>
                <option value="">Select Yard</option>

                {yardList.map((item) => (
                  <option key={item.id} value={item.yard_name}>
                    {item.yard_name}
                  </option>
                ))}
              </select>
            </div>

            <div className="col-md-6 mb-3">
              <label>Yard Address *</label>

              <textarea
                name="yard_address"
                className="form-control"
                rows="3"
                value={formData.yard_address}
                onChange={handleChange}
              />
            </div>

            <div className="col-md-12">
              <div className="d-flex justify-content-end gap-2">
                <button className="btn btn-secondary" onClick={() => navigate(-1)}>
                  Back
                </button>

                {/* --- PRELOADER: Save button disabled while POST is in-flight --- */}
                <button
                  className="btn btn-primary"
                  onClick={handleSave}
                  disabled={postLoading}
                  style={{ opacity: postLoading ? 0.7 : 1 }}
                >
                  {postLoading ? 'Saving...' : 'Save'}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showPopup && (
        <div className="modal d-block" tabIndex="-1">
          <div className="modal-dialog modal-dialog-centered">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Repair Required?</h5>
              </div>

              <div className="modal-body">
                <p>Is Repair required?</p>
              </div>

              <div className="modal-footer">
                <button className="btn btn-danger" onClick={() => finalSave('no')}>
                  No
                </button>

                <button className="btn btn-success" onClick={() => finalSave('yes')}>
                  Yes
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default ScheduleInspectionYardPlacement;
